import React from 'react'
import PropTypes from 'prop-types'
import { connectPagination, connectStateResults } from 'react-instantsearch-dom'
import MuiPagination from '@material-ui/lab/Pagination'
import TablePagination from 'components/pagination/table-pagination'

function NumberedPagination({
  currentRefinement,
  nbPages,
  refine,
  size,
  showFirstButton,
  showLastButton,
  siblingCount,
  boundaryCount,
}) {
  if (nbPages == null || nbPages <= 1) {
    return null
  }

  const onPageChange = (_, value) => {
    refine(value)
    window.scrollTo(0, 0)
  }

  return (
    <MuiPagination
      count={nbPages}
      page={currentRefinement}
      variant="outlined"
      shape="rounded"
      color="primary"
      size={size || 'large'}
      showFirstButton={showFirstButton}
      showLastButton={showLastButton}
      siblingCount={siblingCount}
      boundaryCount={boundaryCount}
      onChange={onPageChange}
    />
  )
}

function TableStylePagination({
  currentRefinement,
  nbPages,
  refine,
  searchResults,
  alwaysShowCount = false,
}) {
  const nbHits = searchResults?.nbHits ?? 0
  const hitsPerPage = searchResults?.hitsPerPage ?? 12
  const pageCount = nbPages || Math.max(1, Math.ceil(nbHits / hitsPerPage))

  if (!searchResults || nbHits === 0) {
    return null
  }

  if (!alwaysShowCount && pageCount <= 1) {
    return null
  }

  const page = currentRefinement - 1

  return (
    <TablePagination
      page={page}
      pageCount={pageCount}
      rowsPerPage={hitsPerPage}
      totalCount={nbHits}
      alwaysShowCount={alwaysShowCount}
      onPageChange={nextPage => {
        refine(nextPage + 1)
        window.scrollTo(0, 0)
      }}
    />
  )
}

TableStylePagination.propTypes = {
  alwaysShowCount: PropTypes.bool,
}

function Pagination({
  variant = 'numbered',
  searchResults,
  isSearchStalled: _isSearchStalled,
  searching: _searching,
  alwaysShowCount,
  ...numberedProps
}) {
  if (variant === 'table') {
    return (
      <TableStylePagination
        {...numberedProps}
        searchResults={searchResults}
        alwaysShowCount={alwaysShowCount}
      />
    )
  }

  return <NumberedPagination {...numberedProps} />
}

Pagination.propTypes = {
  variant: PropTypes.oneOf(['numbered', 'table']),
}

export const AlgoliaPagination = connectPagination(
  connectStateResults(Pagination),
)
